import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SideQuizService {

  quizOpened = new BehaviorSubject(false);
  quizActive: BehaviorSubject<boolean | string> = new BehaviorSubject(false);

  constructor() { }
}
